<template>
    <div class="container mt-5">
        <div class="h1 text-center"><strong>付款狀態</strong></div>
        <div class="row justify-content-center mt-3">
            <div class="col-md-8 text-center">
                <div class="alert alert-rounded " :class="this.code==1 ? 'alert-success':'alert-danger'" role="alert">
                    {{paystatus}}</div>
                <div class="h4">購買資訊</div>
                <table class="table table-sm my-4">
                    <thead>
                        <tr>
                            <th width="100"></th>
                            <th>商品名稱</th>
                            <th>商品資訊</th>
                            <th class="text-center" width="50">數量</th>
                            <th class="text-center" width="80">小計</th>
                        </tr>
                    </thead>
                    <tbody v-for="item in products">
                        <tr>
                            <td class="align-middle">
                                <div class="card p-1 card-bottom">
                                    <img :src="base_url+'/uploads/'+item.image" alt="" width="80px;">
                                </div>
                            </td>
                            <td class="align-middle ">{{item.name}}</td>
                            <td class="align-middle ">
                                <p v-for="(val, index) in item.information" :key="index">{{index}}：{{val}}</p>
                            </td>
                            <td class="align-middle text-center">{{item.quantity}}</td>
                            <td class="align-middle text-center">{{item.price}}</td>
                        </tr>
                    </tbody>
                    <tbody>
                        <tr class="text-right">
                            <td colspan="4" class="text-right"><strong>合計</strong></td>
                            <td class="text-center"><strong>{{total}}</strong></td>
                        </tr>
                    </tbody>
                </table>


                <div class="h4 mt-5">個人資料</div>
                <table class="table  mt-3 text-left">
                    <tbody>
                        <tr>
                            <th>訂單編號</th>
                            <td>{{uid}}</td>
                        </tr>
                        <tr>
                            <th>交易時間</th>
                            <td>{{trade}}</td>
                        </tr>
                        <tr>
                            <th>付款人姓名</th>
                            <td>{{payman.name}}</td>
                        </tr>
                        <tr>
                            <th>電話</th>
                            <td>{{payman.phone}}</td>
                        </tr>
                        <tr>
                            <th>地址</th>
                            <td>{{payman.address}}</td>
                        </tr>
                        <tr>
                            <th>付款方式</th>
                            <td>{{pay}}&nbsp;&nbsp;&nbsp;&nbsp;<button class="btn btn-primary" v-if="atm_info!=null"
                                    @click="display">顯示</button></td>
                        </tr>
                    </tbody>
                </table>
                <modal ref="dis" name="ATM帳號資訊" v-if="atm_info!=null">
                    <template v-slot:default>
                        <div class="from-group col-md-12">
                            <div class="text-left">銀行代碼：{{atm_info.bank_code}}</div>
                            <div class="text-left">匯款帳號：{{atm_info.account}}</div>
                        </div>
                    </template>
                    <template v-slot:footer>
                        <div class="col-md-12">
                            <button class="btn btn-primary col-md-6" @click="closedisplay">OK</button>
                        </div>
                    </template>
                </modal>
            </div>
        </div>
        <div class="text-center mt-4">
            <a :href="base_url+'/admin/order'" class="btn btn-primary px-5">回列表</a>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            uuid: {
                default: 0
            }
        },
        data() {
            return {
                base_url,
                uid: '',
                trade: '',
                payman: '',
                pay: '',
                products: '',
                total: '',
                paystatus: '',
                information: '',
                proname: '',
                code: '',
                atm_info: '',
            }
        },
        mounted() {
            console.log('Component mounted.')
        },
        methods: {
            openmodal(information, name) {
                this.$refs.info.modalShow();
                console.log(information, name);
                this.information = information;
                this.proname = name;
            },
            getorder: function () {
                axios
                    .get(base_url + '/api/orders/' + this.uuid)
                    .then((response) => {
                        console.log(response.data);
                        console.log(response.data.payment.atm_info);
                        this.uid = response.data.uuid;
                        this.trade = response.data.timeline.trade_date;
                        this.payman = response.data.payman;
                        this.pay = response.data.payment.method;
                        this.products = response.data.items;
                        this.total = response.data.payment.amount;
                        this.paystatus = response.data.payment.status;
                        this.code = response.data.payment.code;
                        this.atm_info = response.data.payment.atm_info;
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            },
            closemodal: function () {
                this.$refs.info.modalHide();
            },
            display: function () {
                this.$refs.dis.modalShow();
            },
            closedisplay: function () {
                this.$refs.dis.modalHide();
            },
        },
        created() {
            this.getorder();
        },
    }
</script>